import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";

const COVER_BG = ["bg-brand-pink", "bg-brand-yellow", "bg-brand-green", "bg-brand-blue"];

function formatDate(d) {
    try {
        return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return "";
    }
}

export default function BlogCard({ post, index = 0 }) {
    const bg = COVER_BG[index % COVER_BG.length];
    return (
        <Link
            to={`/blog/${post.slug}`}
            data-testid={`blog-card-${post.slug}`}
            className="group block brutal-card p-0 overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:-translate-x-1 hover:shadow-brutal-xl"
        >
            <div className={`aspect-[16/10] border-b-[3px] border-ink ${bg} relative overflow-hidden`}>
                {post.cover_image ? (
                    <img
                        src={post.cover_image}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center font-display text-5xl font-black">
                        {post.title.charAt(0)}
                    </div>
                )}
                {post.tag && (
                    <span className="absolute top-4 left-4 label-mono bg-white border-2 border-ink rounded-full px-3 py-1">
                        {post.tag}
                    </span>
                )}
            </div>
            <div className="p-6 md:p-7">
                <div className="flex items-center gap-2 label-mono text-ink/60">
                    <Calendar size={12} /> {formatDate(post.created_at)}
                </div>
                <h3 className="mt-3 font-display text-2xl md:text-3xl font-black leading-tight tracking-tight">
                    {post.title}
                </h3>
                <p className="mt-3 font-body text-ink/70 leading-relaxed line-clamp-3">{post.excerpt}</p>
                <span className="mt-5 inline-flex items-center gap-1 font-display font-bold group-hover:gap-2 transition-all">
                    Read more <ArrowUpRight size={18} />
                </span>
            </div>
        </Link>
    );
}
